import { render, staticRenderFns } from "./BadgeForm.vue?vue&type=template&id=ddfee92e&scoped=true"
import script from "./BadgeForm.vue?vue&type=script&lang=js"
export * from "./BadgeForm.vue?vue&type=script&lang=js"
import style0 from "./BadgeForm.vue?vue&type=style&index=0&id=ddfee92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfee92e",
  null
  
)

export default component.exports